import {Injectable} from '@angular/core';

import { ValidatorProvider } from '../../providers/validator/validator';
import { AuthProvider } from '../../providers/auth/auth';
import { ProofServerProvider } from "../../providers/proof-server/proof-server";
import { UploadingProvider } from '../../providers/uploading/uploading';

import * as Config from "../../app/app.config";

/*
  Generated class for the RegistrationProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class RegistrationProvider {
    private proof = null;
    private user = null;
    private userFilesGet: any[] = [];

    constructor(
        private validatorProvider: ValidatorProvider,
        private authProvider: AuthProvider,
        private proofServerProvider: ProofServerProvider,
        private uploadingprovider: UploadingProvider        
    ) {
        this.user = this.authProvider.getUser();
        console.log('Hello RegistrationProvider Provider');

        this.proofServerProvider.getById(Config.proofId).subscribe(proof => {
          this.proof = proof;
        });

        this.uploadingprovider.listTitlesFiles(this.user.id).subscribe((response: any) => {
          if (response) {
            response.forEach(data => {
              if (data.titleId == 18) {
                this.userFilesGet.push(data);
              }
            });
          }
        });
    }

    isComplete(callback = null) {
      const user = this.authProvider.getUser();

      const checkUserData = () => {
        return (
          ((!this.validatorProvider.isEmpty(user.address)) &&
            (!this.validatorProvider.isEmpty(user.addressNumber)) &&
            (!this.validatorProvider.isEmpty(user.addressCountry)) &&
            (!this.validatorProvider.isEmpty(user.addressCity)) &&
            (!this.validatorProvider.isEmpty(user.addressState)) &&
            // (this.userFilesGet.length !== 0) &&
            (!this.validatorProvider.isEmpty(user.addressZip))) &&
          ((user.genre !== null) &&
            (user.nationality !== null) &&
            (!this.validatorProvider.isEmpty(user.birthPlace))) &&
          (!this.validatorProvider.isEmpty(user.motherName)) &&
          ((user.documentKind !== null) &&
            (!this.validatorProvider.isEmpty(user.documentCode)) &&
            (user.scholarity !== null))
        );
      };

      if (callback === null) {
        return checkUserData();
      }

      this.proofServerProvider.getById(Config.proofId).subscribe(proof => {
        if (proof.hasMandatoryDocumentation === '1') {
          callback(false);
        } else {
          callback(checkUserData());
        }
      });
    }

    isComplete_() {
      const user = this.authProvider.getUser();

      return (
        ((!this.validatorProvider.isEmpty(user.address)) &&
          (!this.validatorProvider.isEmpty(user.addressNumber)) &&
          (!this.validatorProvider.isEmpty(user.addressCountry)) &&
          (!this.validatorProvider.isEmpty(user.addressCity)) &&
          (!this.validatorProvider.isEmpty(user.addressState)) &&
          (this.userFilesGet.length !== 0) &&
          (!this.validatorProvider.isEmpty(user.addressZip))) &&
        ((user.genre !== null) &&
          (user.nationality !== null) &&
          (!this.validatorProvider.isEmpty(user.birthPlace))) &&
        (!this.validatorProvider.isEmpty(user.motherName)) &&
        ((user.documentKind !== null) &&
          (!this.validatorProvider.isEmpty(user.documentCode)) &&
          (user.scholarity !== null))
      );
    }
}



// WEBPACK FOOTER //
// ./src/providers/registration/registration.ts